"use client";

import { useState } from "react";
import { NewCollabDialog } from "@frontend/components/new-collab-dialog";

/**
 * The way in to booking someone. Until this existed the only route to an offer
 * was knowing the creator's page URL, which works for a link someone sent you
 * and not at all for booking the person you worked with last month.
 */
export function NewCollabButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="inline-flex size-10 shrink-0 items-center justify-center gap-1.5 rounded-lg bg-brand-600 text-sm font-medium text-canvas transition hover:bg-brand-700 focus-visible:ring-4 focus-visible:ring-brand-100 focus-visible:outline-none sm:h-auto sm:w-auto sm:px-3 sm:py-2"
      >
        <PlusIcon />
        <span className="hidden sm:inline">New collab</span>
        <span className="sr-only sm:hidden">New collab</span>
      </button>

      {open ? <NewCollabDialog onClose={() => setOpen(false)} /> : null}
    </>
  );
}

function PlusIcon() {
  return (
    <svg viewBox="0 0 16 16" fill="none" className="size-4" aria-hidden="true">
      <path d="M8 3.5v9M3.5 8h9" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  );
}
